import React, { useState, useEffect } from "react";
import {
  Container,
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
  Label,
  Input,
  Button,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { NavLink, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { directUrl, homePageUrl } from "../../../helpers/Constants";
import { requestApi } from "../../../request-api";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function CreateAuditor() {
  let [calendarValue, setCalenderValue] = useState(new Date());
  let [showCalender, setShowCalender] = useState(false);
  let [selectedDate, setSelectedDate] = useState("");
  const [auditorName, setAuditorName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const [startDate, setStartDate] = useState(new Date());
  let navigate = useNavigate()


  const successToast = (message) => toast.success(message, {
    position: "bottom-right"
  });

  const errorToast = (error) => toast.error(error, {
    position: "bottom-right"
  });

  const createHandler = () => {

    requestApi("/auditor/register", {
      method: "post",
      body: JSON.stringify({
        name: auditorName,
        email: email,
        phone_number: phoneNumber
      })

    })
      .then((data) => {
        if (data.statusCode == 200) {

          setMessage('')
          setMessage(data.message)
          successToast("Auditor created successfully")
          navigate(`${directUrl}super-admin/auditor`)
        }
        else {
          errorToast(data.message)
          console.log("data of register ", data.message)
        }

      })
      .catch((error) => {
        setError('')
        setError(error.message)
        errorToast(error.message)
      });
  }

  useEffect(() => {
    setSelectedDate(
      `${calendarValue.getDate()}/${calendarValue.getMonth() + 1
      }/${calendarValue.getFullYear()}`
    );
  }, [calendarValue]);

  return (
    <section className="lyt-section">
      <Container fluid className="typ-container">
        <Breadcrumb className="bs-breadcrumb mt-0">
          <BreadcrumbItem>
            <NavLink to={`${directUrl}super-admin/auditor`}>Auditor</NavLink>
          </BreadcrumbItem>
          <BreadcrumbItem active>Create Auditor</BreadcrumbItem>
        </Breadcrumb>
        <div className="bs-card px-0">
          <div className="padding-area">
            <form className="bs-form">
              <Row>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <div className='form-box'>
                    <Label for="doj" className="mr-sm-2 cstm-label">
                      Auditor’s Name
                    </Label>
                    <Input
                      type="text"
                      name="name"
                      id="name"
                      className="cstm-input"
                      onChange={(e) => setAuditorName(e.target.value)}
                      placeholder="Enter Auditor’s Name"
                      required
                    />
                  </div>
                </Col>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <div className='form-box'>
                    <Label for="doj" className="mr-sm-2 cstm-label">
                      Email ID
                    </Label>
                    <Input
                      type="email"
                      name="email"
                      id="email"
                      email
                      className="cstm-input"
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter Email ID"
                      required
                    />
                  </div>
                </Col>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <div className='form-box'>
                    <Label for="doj" className="mr-sm-2 cstm-label">
                      Contact Number
                    </Label>
                    <Input
                      type="text"
                      name="phoneNumber"
                      id="phone"
                      className="cstm-input"
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      placeholder="Enter Contact Number"
                    />
                  </div>
                </Col>
                {error ? <p style={{ fontSize: '12px', color: "#d73038", fontFamily: 'roboto', fontWeight: 500 }}>{error}</p> : message ? <p style={{ fontSize: '12px', color: "#00FF00", fontFamily: 'roboto', fontWeight: 500 }}>{message}</p> : null}


                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                  <button className="bs-btn" type="button" onClick={createHandler}>SUBMIT</button>
                </Col>
              </Row>
            </form>
          </div>
        </div>
        <ToastContainer />
      </Container>
    </section>
  );
}

export default CreateAuditor;
